var App = App || {};

App.WidgetFaqSimple = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {

            var component = selector;
            var accordion = component.find(".accordion");
            var control = component.find(".widget-faqSimple-control > button");

            control.on("click", function () {
                var expanded = $(this).attr("aria-expanded") == "true";
                var panels = accordion.find(".accordion-item-more")
                if (!expanded) {
                    $(this).attr("aria-expanded", "true");
                    panels.show();
                }
                else {
                    $(this).attr("aria-expanded", "false");
                    panels.hide();
                }
            });

        }
    }

    return {
        Init: Init
    };

})(jQuery);